// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__AG6gQ","col":"styles_col__3njgo"};